import { useQuery } from '@tanstack/react-query';
import { ReactQueryKeys } from '@/utils/react-query-keys';
import { getCompanySearch } from '@/services/dashboard-service/dashboard.service';

interface UseCompanySearchProps {
  query: string;
}

export const useCompanySearch = ({ query }: UseCompanySearchProps) => {
  const {
    data: companySearchData,
    isPending: companySearchLoading,
    error,
  } = useQuery({
    queryKey: ReactQueryKeys.COMPANY_SEARCH({ query }),
    queryFn: () => getCompanySearch({ query }),
    staleTime: 5 * 60 * 1000,
    enabled: query.length > 0,
    retry: false,
    throwOnError: false,
  });

  const actualLoading = query.length > 0 ? companySearchLoading : false;

  const safeData = error ? [] : companySearchData;

  return {
    companySearchData: safeData,
    companySearchLoading: actualLoading,
    companySearchError: error,
  };
};
